import './LiksToggleGroup.css';

export type LiksToggleOption = {
  value: string;
  label: string;
};

export type LiksToggleGroupProps = {
  name: string;
  legend: string;
  /** When `null`, no option is selected (e.g. custom slider values). */
  value: string | null;
  options: LiksToggleOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
};

export function LiksToggleGroup({
  name,
  legend,
  value,
  options,
  onChange,
  disabled = false,
  className,
}: LiksToggleGroupProps) {
  return (
    <fieldset
      className={[
        'liks-toggle-group',
        disabled && 'liks-toggle-group--disabled',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      disabled={disabled}
    >
      <legend className="liks-toggle-group__legend">{legend}</legend>
      {options.map((option) => {
        const inputId = `${name}-${option.value}`;

        return (
          <label key={option.value} className="liks-toggle-group__option">
            <input
              id={inputId}
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              disabled={disabled}
              onChange={() => onChange(option.value)}
            />
            <span>{option.label}</span>
          </label>
        );
      })}
    </fieldset>
  );
}
